import { useEffect, useState } from "react";
import { fetchWeatherData, type WeatherData } from "@/services/weatherService";
import { getWeatherIcon } from "@/utils/weatherIcons";

interface WeatherWidgetProps {
  location: string;
  lat: number;
  lon: number;
  apiKey?: string;
}

export const WeatherWidget = ({ location, lat, lon, apiKey }: WeatherWidgetProps) => {
  const [weather, setWeather] = useState<WeatherData>({
    location: location,
    description: "Cargando...",
    temp: 0,
    weatherCode: 800
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWeather = async () => {
      try {
        const data = await fetchWeatherData(location, lat, lon, apiKey);
        setWeather(data);
      } catch (error) {
        // Fallback to mock data if API fails
        setWeather({
          location: location,
          description: "Parcialmente nublado",
          temp: 18,
          weatherCode: 801
        });
      } finally {
        setLoading(false);
      }
    };

    loadWeather();
  }, [lat, lon, location, apiKey]);

  const WeatherIcon = getWeatherIcon(weather.weatherCode);
  const weatherTone = weather.weatherCode >= 200 && weather.weatherCode < 300
    ? "is-storm"
    : weather.weatherCode >= 300 && weather.weatherCode < 600
      ? "is-rain"
      : weather.weatherCode === 800
        ? "is-sunny"
        : "is-cloudy";

  return (
    <section className={`weather-widget ${weatherTone}`} aria-label="Información meteorológica">
      <div className="weather-wave weather-wave-a" />
      <div className="weather-wave weather-wave-b" />
      <div className="weather-left">
        <div className="weather-location">{weather.location}</div>
        <div className="weather-desc">
          {loading ? "Cargando..." : weather.description}
        </div>
      </div>
      <div className="weather-right">
        <div className="weather-icon-wrap">
          <WeatherIcon className="weather-icon" strokeWidth={1.8} />
        </div>
        <div className="weather-temp">{weather.temp}°</div>
      </div>
    </section>
  );
};
